module.exports = __webpack_public_path__ + "img/UrbanMining.bf10f67.webp";